import { getInternationalizedDate } from "@repo/ui/utils/dateI18n";

// The one format for every Wallet amount (page, banners, modals): change it here, not per screen.
// Intl rounds half-up on the decimal value: 12.344 -> "12.34", 12.345 -> "12.35", 215.3 -> "215.30".
const walletAmountFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatWalletAmount(n: number): string {
  return walletAmountFormatter.format(n);
}

export function formatCreditDate(iso: string): string {
  return getInternationalizedDate(iso, "MM/dd/yyyy");
}

/** Short-year expiry date for compact list rows, e.g. "03/13/27". */
export function formatReservationExpiryDate(iso: string): string {
  return getInternationalizedDate(iso, "MM/dd/yy");
}

export function formatExpirationDate(iso?: string): string {
  if (!iso) return "";
  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  }).format(new Date(iso));
}

/** Formats a date as a long-form label, e.g. "November 12, 2025". */
export function formatMovementDate(iso: string): string {
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(new Date(iso));
}

/**
 * Formats a date for use as a group-section label (e.g. "November 12, 2025"),
 * collapsing to `todayLabel` when the date matches `today`.
 */
export function formatGroupDateLabel(iso: string, today: string, todayLabel: string): string {
  return iso === today ? todayLabel : formatMovementDate(iso);
}
